import i18n from '@/i18n';
import moment from 'moment';
import H_time from '@/helpers/time';
import H_taskTemplate from '@/helpers/taskTemplate';
import H_factorySystemClass from '@/helpers/factorySystemClass';
import systemClass from '@/service/api/v1/system_class';
import Spare_change from '@/spare/change';

function pickIds(list) {
  return (list || []).map(item => item?.id ?? item);
}

function uniqIds(ids) {
  return [...new Set(ids)];
}

function moduleDataToSelectValue({ system_classes, system_subclasses, factory_system_classes }) {
  return {
    system_classes: (system_classes || []).map(id => ({ id })),
    system_subclasses: (system_subclasses || []).map(id => ({ id })),
    factory_system_classes: (factory_system_classes || []).map(id => ({ id })),
    factory_system_subclasses: [],
  };
}

function mergeMultiSystemClassesSelectValues(...values) {
  return {
    system_classes: uniqIds(values.flatMap(v => pickIds(v?.system_classes))),
    system_subclasses: uniqIds(values.flatMap(v => pickIds(v?.system_subclasses))),
    factory_system_classes: uniqIds(values.flatMap(v => pickIds(v?.factory_system_classes))),
    factory_system_subclasses: uniqIds(values.flatMap(v => pickIds(v?.factory_system_subclasses))),
  };
}

function buildSystemClassIdMap(multiSystemClassMenu) {
  const map = {};
  const root = (multiSystemClassMenu || []).find(node => node.id === 'systemClass');
  (root?.items || []).forEach(row => {
    (row.items || []).forEach(leaf => {
      map[leaf.id] = row.id;
    });
  });
  return map;
}

function buildFactoryClassIdMap(multiSystemClassMenu) {
  const map = {};
  const root = (multiSystemClassMenu || []).find(node => node.id === 'factorySystemClass');
  (root?.items || []).forEach(row => {
    (row.items || []).forEach(leaf => {
      map[leaf.id] = row.id;
    });
  });
  return map;
}

function getAllowedSubclassIds(multiSystemClassMenu) {
  const system = [];
  const factory = [];
  (multiSystemClassMenu || []).forEach(root => {
    if (root.id === 'systemClass') {
      (root.items || []).forEach(row => {
        (row.items || []).forEach(leaf => system.push(leaf.id));
      });
    }
    if (root.id === 'factorySystemClass') {
      (root.items || []).forEach(row => {
        (row.items || []).forEach(leaf => factory.push(leaf.id));
      });
    }
  });
  return { system, factory };
}

function getFactorySubclassList(version) {
  if (!version) return [];
  if (version.factory_system_subclasses?.length) {
    return version.factory_system_subclasses;
  }
  return version.factory_system_classes || [];
}

function formatSubclassChips(subclasses) {
  return (subclasses || []).map(subclass => ({
    text: subclass.name,
    icon: subclass.icon,
    id: subclass.id,
  }));
}

function getVersionDomainChips(version) {
  const merged = H_taskTemplate.mergeMultiSystemSubclasses(
    version?.system_subclasses,
    getFactorySubclassList(version),
  );
  return formatSubclassChips(merged);
}

function getTemplateSystemSubclassIds(quesList) {
  const ids = [];
  (quesList || []).forEach(ques => {
    if (ques.score && ques.score !== 12 && ques.systemSubclasses?.length) {
      ques.systemSubclasses.forEach(subclass => ids.push(subclass.id));
    }
  });
  return uniqIds(ids);
}

export default {
  formatSubclassChips,
  getVersionDomainChips,
  getFactorySubclassList,
  setIndex(list) {
    const _list = list.map(item => {
      return {
        id: item.id,
        updateAt: H_time.getDateDashFormat(item.updated_at),
        condition: this.setChangeStatus(item.change_status),
        name: item.name,
        systemSubclasses: item.last_version
          ? H_taskTemplate.mergeMultiSystemSubclasses(
              item.last_version.system_subclasses,
              item.last_version.factory_system_subclasses
            )
          : [],
        owner: item.last_version ? item.last_version.owner : {},
        expiredData:
          item.last_version && item.last_version.expired_date
            ? this.setExpiredData(item.last_version.expired_date)
            : {},
      };
    });
    return _list;
  },
  setChangeStatus(status) {
    if (status === 1) {
      return {
        text: i18n.t('評估中'),
        color: 'yellow',
      };
    }
    if (status === 2) {
      return {
        text: i18n.t('中止'),
        color: 'lightGray',
      };
    }
    if (status === 3) {
      return {
        text: i18n.t('執行中'),
        color: 'green',
      };
    }
    if (status === 4) {
      return {
        text: i18n.t('已結案'),
        color: 'darkGray',
      };
    }
  },
  setExpiredData(date) {
    const today = moment(new Date());
    const expiredDate = moment(date);
    return {
      icon: 'icon-duedate',
      color: today.diff(expiredDate, 'days', true) > 0 ? 'red' : '',
      text: H_time.getDateDashFormat(date),
    };
  },
  setTabAmount(rawData) {
    const tabList = [...Spare_change.tabList];
    const { status_1_count, status_2_count, status_3_count, status_4_count, total_count } =
      rawData;
    tabList.forEach(tab => {
      tab.num =
        tab.id === '1'
          ? status_1_count
          : tab.id === '2'
            ? status_2_count
            : tab.id === '3'
              ? status_3_count
              : tab.id === '4'
                ? status_4_count
                : total_count;
    });
    return tabList;
  },
  aggregateSubclassSelectValue(quesList, quesListAdd) {
    const values = [];
    const templateSubclassIds = getTemplateSystemSubclassIds(quesList);
    if (templateSubclassIds.length) {
      values.push(
        H_factorySystemClass.getTemplateMultiSystemClassesSelectValue(templateSubclassIds),
      );
    }
    (quesListAdd || []).forEach(ques => {
      if (!ques.multiSystemClasses?.length) return;
      values.push(
        moduleDataToSelectValue(
          H_factorySystemClass.setSubmitModuleData(ques.multiSystemClasses),
        ),
      );
    });
    if (!values.length) {
      return H_factorySystemClass.getEmptyMultiSystemClassesSelectValue();
    }
    return mergeMultiSystemClassesSelectValues(...values);
  },
  getExamSubclassIdsFromQuestions(quesList, quesListAdd) {
    const aggregated = this.aggregateSubclassSelectValue(quesList, quesListAdd);
    return {
      system_subclasses: pickIds(aggregated.system_subclasses),
      factory_system_subclasses: uniqIds([
        ...pickIds(aggregated.factory_system_classes),
        ...pickIds(aggregated.factory_system_subclasses),
      ]),
    };
  },
  buildChangeVersionPayload(quesList, quesListAdd, systemSubclassesItems) {
    const aggregated = this.aggregateSubclassSelectValue(quesList, quesListAdd);
    const payload = H_factorySystemClass.setSubmitDataFromSelectValue(aggregated);
    if (payload.system_subclasses.length && !payload.system_classes.length && systemSubclassesItems) {
      payload.system_classes = systemClass.getSelectedSystemClasses(
        payload.system_subclasses,
        systemSubclassesItems,
      );
    }
    return payload;
  },
  buildAvatarParams(quesList, quesListAdd, systemSubclassesItems) {
    const examIds = this.getExamSubclassIdsFromQuestions(quesList, quesListAdd);
    const versionPayload = this.buildChangeVersionPayload(
      quesList,
      quesListAdd,
      systemSubclassesItems,
    );
    return {
      system_classes: versionPayload.system_classes,
      system_subclasses: examIds.system_subclasses,
      factory_system_subclasses: examIds.factory_system_subclasses,
    };
  },
  buildEvaluatorSelectItems(quesList, quesListAdd) {
    const items = [];
    const seen = new Set();
    const addItem = (id, subclassType) => {
      const key = `${subclassType}:${id}`;
      if (seen.has(key)) return;
      seen.add(key);
      items.push({ id, subclassType });
    };
    (quesList || []).forEach(ques => {
      if (ques.score && ques.score !== 12 && ques.systemSubclasses?.length) {
        ques.systemSubclasses.forEach(subclass => addItem(subclass.id, 'system'));
      }
    });
    (quesListAdd || []).forEach(ques => {
      const { system_subclasses, factory_system_subclasses } =
        H_factorySystemClass.getExamSubclassIdsFromMultiSystemClasses(
          ques.multiSystemClasses || [],
        );
      system_subclasses.forEach(id => addItem(id, 'system'));
      factory_system_subclasses.forEach(id => addItem(id, 'factory'));
    });
    return items;
  },
  buildListBySystemSubclassFromCustomQuestion(change, multiSystemClassMenu) {
    const arrayBySubclass = [];
    const { system_subclasses, factory_system_subclasses } =
      H_factorySystemClass.getExamSubclassIdsFromMultiSystemClasses(
        change.multiSystemClasses || [],
      );
    const systemClassIdBySubclass = buildSystemClassIdMap(multiSystemClassMenu);
    const factoryClassIdBySubclass = buildFactoryClassIdMap(multiSystemClassMenu);

    system_subclasses.forEach(subclassId => {
      arrayBySubclass.push({
        subclassType: 'system',
        subclassId,
        classId: systemClassIdBySubclass[subclassId],
        riskList: [{ name: change.riskCountersign }],
      });
    });
    factory_system_subclasses.forEach(subclassId => {
      arrayBySubclass.push({
        subclassType: 'factory',
        subclassId,
        factoryClassId: factoryClassIdBySubclass[subclassId],
        riskList: [{ name: change.riskCountersign }],
      });
    });
    return arrayBySubclass;
  },
  buildCustomQuestionModuleData(change) {
    return H_factorySystemClass.setSubmitModuleData(change.multiSystemClasses || []);
  },
  enrichTemplateQuesListClassIds(quesListWithindex, multiSystemClassMenu) {
    const systemClassIdBySubclass = buildSystemClassIdMap(multiSystemClassMenu);
    (quesListWithindex || []).forEach(changeItem => {
      (changeItem.listBySystemSubclass || []).forEach(subclassListItem => {
        if (subclassListItem.subclassType === 'factory' || subclassListItem.classId) return;
        subclassListItem.classId = systemClassIdBySubclass[subclassListItem.subclassId];
      });
    });
  },
  getAllowedSubclassIds(multiSystemClassMenu) {
    return getAllowedSubclassIds(multiSystemClassMenu);
  },
  getFactoryClassIdBySubclass(subclassId, multiSystemClassMenu) {
    const map = buildFactoryClassIdMap(multiSystemClassMenu);
    return map[String(subclassId)];
  },
  matchEvaluatorFromLastList(item, evaluatorListLast) {
    return (evaluatorListLast || []).find(
      prev =>
        prev.subclassType === item.subclassType &&
        prev.systemSubclass.id === item.systemSubclass.id,
    );
  },
  createEmptyCustomQuestionFields() {
    return {
      multiSystemClasses: [],
      multiSystemClassesSelectValue: H_factorySystemClass.getEmptyMultiSystemClassesSelectValue(),
    };
  },
};
